import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const Arrow3 = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      viewBox="0 0 24 24"
      width={computedSize}
      height={computedSize}
      {...props}
    >
      <path
        fill="#303032"
        fillRule="evenodd"
        d="M4.618 16.145a.75.75 0 0 1-.263-1.027L5 15.5l-.645-.382.004-.007.01-.016.037-.062.14-.23c.123-.196.3-.475.52-.81a35 35 0 0 1 1.776-2.46c.711-.893 1.534-1.813 2.38-2.516C10.04 8.337 11.01 7.75 12 7.75s1.96.587 2.777 1.267c.847.703 1.67 1.623 2.38 2.516a35 35 0 0 1 2.437 3.5l.037.062.01.016.004.006L19 15.5l.645-.383a.75.75 0 0 1-1.29.765m0 0-.002-.003-.009-.014-.033-.055-.132-.215a33.356 33.356 0 0 0-2.195-3.128c-.682-.857-1.431-1.687-2.165-2.296-.762-.633-1.382-.921-1.819-.921s-1.057.288-1.82.92c-.733.61-1.482 1.44-2.164 2.297a33 33 0 0 0-2.327 3.343l-.034.055-.008.014-.001.003a.75.75 0 0 1-1.028.263"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default Arrow3;
